<div *ngFor="let validation of messages">
  <div class="error-message"
    *ngIf="formControl.hasError(validation.type) && (formControl.dirty || formControl.touched)">
    {{validation.message}}</div>
</div>
